export default function Fourth() {
  return (
    <>
      <g style={{ mixBlendMode: 'hard-light' }} id="g1">
        <path
          d="M 234,171.13474 V 95 L 14.621939,55.68465 c 0,0 -7.49986,3.5 -1.99993,15.5 5.49993,12 15.00003,6.5 15.00003,6.5 z"
          fill="url(#paint0_linear_527_13)"
          fillOpacity="0.9"
        />
      </g>
      <defs id="defs2">
        <linearGradient
          id="paint0_linear_527_13"
          x1="-2.94697e-06"
          y1="6.00001"
          x2="255.11"
          y2="61.9967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE32B" />
          <stop offset="1" stopColor="#B60C00" />
        </linearGradient>
      </defs>
    </>
  );
}
